import React, { Dispatch, ReactNode, RefObject, SetStateAction, useContext, useEffect, useId, useMemo, useRef, useState } from "react";
import { Smashchange } from "../../components/cursor/Smashchange";
import { Img100 } from "../../components/Img100";
import { FreeDrag, TargetBehavior } from "../../components/cursor/draggables/FreeDrag";
import { Plzen } from "../../components/cursor/plz/Plzen";
import cloaked_figure from "url:../../assets/xamni/objs/Cloaked Figure.png";
import tite1 from "url:../../assets/xamni/tites/tite-1.png";
import tite2 from "url:../../assets/xamni/tites/tite-2.png";
import tite3 from "url:../../assets/xamni/tites/tite-3.png";
import tite4 from "url:../../assets/xamni/tites/tite-4.png";
import tite5 from "url:../../assets/xamni/tites/tite-5.png";
import tite6 from "url:../../assets/xamni/tites/tite-6.png";
import tite7 from "url:../../assets/xamni/tites/tite-7.png";
import tite8 from "url:../../assets/xamni/tites/tite-8.png";
import tite9 from "url:../../assets/xamni/tites/tite-9.png";
import tite10 from "url:../../assets/xamni/tites/tite-10.png";
import tite11 from "url:../../assets/xamni/tites/tite-11.png";
import tite12 from "url:../../assets/xamni/tites/tite-12.png";
import titewad from "url:../../assets/xamni/tites/tite-wad.png";
import cagefront from "url:../../assets/xamni/tites/cage-front.png";
import cageback from "url:../../assets/xamni/tites/cage-back.png";
import { DialoguePosition, Talker } from "./XANMI";
import { Stated } from "../../components/Stated";
import { Plzma } from "../../components/cursor/plz/Plzma";
import skeleton_beast from "url:../../assets/xamni/objs/Skeleton Beast.png";
import Vector2 from "../../utility/Vector2";
import PlayerProvider from "../../providers/PlayerProvider";
import { CRS_INFO_KY1 } from "../../components/MagicCursor";
import CursorProvider, { CursorState } from "../../providers/CursorProvider";

const SMOG_ID = "smog-the-destroyer";

interface TiteState {
    ps: number, // 0 = no cage, 1 = cage, 2 = cage powered but not in place, 3 = cage in place but not powered, 4 = cage powered and in place, 5 = smog is dead and the portal opens
    tc: number
};

export function XANMIT() {
    const titeBoxRef = useRef(HTMLDivElement.prototype);
    const [state, setState] = useState<TiteState>({ ps: 0, tc: 0});
    const player = useContext(PlayerProvider.context);
    const cursor = useContext(CursorProvider.context);

    const checkTitesLocation = () => {
        let allInPlace = true;
        let inPlaceCount = tites.max;
        const boxBounds = titeBoxRef.current.getBoundingClientRect();
        tites.titeRefs.forEach((t) => {
            const bounds = t.current.getBoundingClientRect();
            if (bounds.top < boxBounds.top || bounds.bottom > boxBounds.bottom)
            {
                allInPlace = false;
                inPlaceCount--;
            }
        });
        let ps = state.ps;
        if (ps == 0 && inPlaceCount >= tites.max)
            ps = 1;
        console.log(inPlaceCount);
        setState({ tc: inPlaceCount, ps });
    };

    const tites = useMemo(() => {
        const tites : ReactNode[] = [];
        const refs : RefObject<HTMLDivElement>[] = [];

        const addTite = (i : number, src: string, x: number, y: number, w: number, mite ?: boolean) => {
            tites.push(<Tite
                i={i}
                key={"tite-" + i}
                src={src}
                x={x} y={y} w={w}
                mite={mite}
                refList={refs}
                onDragEnded={() => {
                    checkTitesLocation();
                }}
            />);
        }

        addTite(1, tite11, 17, 47.14, 8);
        addTite(2, tite2, 73, 45.86, 11);
        // addTite(3, tite12, 88, 54.14, 5, true);
        addTite(4, tite6, 86, 51.29, 10, true);
        addTite(5, tite8, 8, 59.14, 7);
        addTite(6, tite7, 73, 59.29, 10);
        addTite(7, tite3, 84, 60, 9);
        addTite(8, tite1, 76, 66.43, 8);
        addTite(9, tite10, 87, 67.57, 6);
        addTite(10, tite4, 15, 67.57, 8);
        addTite(11, tite9, 2, 68.86, 8);

        return {
            visuals: tites,
            max: tites.length,
            titeRefs: refs
        }
    }, []);

    const cloakman = useMemo(() => {
        return <Cloakman tc={state.tc} maxTc={tites.max} ps={state.ps} />;
    }, [state]);

    const cage = useMemo(() => {
        return <Cage x={5} y={53.71} w={90} ps={state.ps} onInLocation={() => { 
            setState ({ tc: state.tc, ps: 3 }) 
        }} onPowered={() => {
            if (state.ps === 3)
                setState({ tc: state.tc, ps: 4 });
            else if (state.ps === 1)
                setState({ tc: state.tc, ps: 2 });
        }} onUnpowered={() => {
            if (state.ps === 4)
                setState({ tc: state.tc, ps: 3 });
            else if (state.ps === 2)
                setState({ tc: state.tc, ps: 1 });

        }} />;
    }, [state]);

    return <div className="pos-abs no-events" style={{
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    }}>
        <TiteBox x={5} y={53.71} w={90} h={4.3} ref={titeBoxRef} />
        { cloakman }
        <Debugs x={5} y={53.71} w={10} h={2} onClicked={() => { setState({ tc: tites.max, ps: 1})} } />
        { state.ps < 1 ? tites.visuals : null }
        { cage }
        <Smog ps={state.ps} onDead={() => { setState({ tc: state.tc, ps: 5 })}} />
        <PageWipe ps={state.ps} onComplete={() => {
            player.unlockCursor(CRS_INFO_KY1.key);
            cursor.setState(CursorState.KY1);
        }} />
    </div>
}

// interface TiteRef 
// {
//     i : number;
//     ref : RefObject<HTMLDivElement>;
// }

function Debugs(props: {
    x: number,
    y: number,
    w: number,
    h: number,
    onClicked: () => void
}) {
    return <div className="pos-abs yes-events" style={{
        left: props.x.toString() + "%",
        top: props.y.toString() + "%",
        width: props.w.toString() + "%",
        height: props.h.toString() + "%"
    }}>
        <button onClick={props.onClicked}>Debug</button>
    </div>
}

function Tite(props: {
    i : number,
    src: string,
    x: number,
    y: number,
    w: number,
    refList: RefObject<HTMLDivElement>[],
    onDragEnded: () => void;
    mite ?: boolean
}) {
    const mite = props.mite !== undefined ? props.mite : false;
    const id = useId();
    const ref = useRef(HTMLDivElement.prototype);
    const posRef = useRef<Vector2>(new Vector2(0, 0));
    const [check, setCheck] = useState(0);

    useEffect(() => {
        if (!props.refList.includes(ref))
            props.refList.push(ref);

        return () => {
            props.refList.splice(props.refList.indexOf(ref), 1);
        }
    })

    const comp = useMemo(() => {
        return <Smashchange
            className="pos-abs yes-events"
            style={{
                top: props.y.toString() + "%",
                left: props.x.toString() + "%",
                width: props.w.toString() + "%"
            }}
            pre={
                <div id={id} className="pos-abs" style={{ top:0, left:0, width: "100%" }} ref={ref}>
                    <Img100 src={props.src} className="bug-off" />
                    {
                        mite 
                            ? <img src={titewad} className="pos-abs" style={{top:"85%", left: "-5%", width: "110%" }} />
                            : <img src={titewad} className="pos-abs" style={{top:"-5%", left: "-5%", width: "110%" }} />
                    }
                </div>
            }
            post={
                <Plzma className="pos-abs width-100p"
                    onEnable={() => { setCheck(check + 1); }}
                    onDisable={() => { setCheck(check + 1); }}
                    onState={
                        <div className="pos-abs width-100p" style={{ top: posRef.current.y, left: posRef.current.x }}>
                            <Img100 id={id} src={props.src} className="pos-abs width-100p electric-pulse-3s" />
                        </div>
                    }
                    offState={
                        <FreeDrag id={id} x={posRef.current.x} y={posRef.current.y} w={"100%"} posRef={posRef} dragRef={ref} onDragEnded={(r) => {
                            if (props.onDragEnded !== undefined)
                                props.onDragEnded();
                        }}>
                            <Img100 id={id} src={props.src} className="bug-off" />
                        </FreeDrag>
                    }
                />
            }
        />;
    }, [check]);

    return comp;
}

function TiteBox(props: {
    x: number,
    y: number,
    w: number,
    h: number,
    ref: RefObject<HTMLDivElement>
}) {
    return <div className="pos-abs opacity-0 no-events" style={{
        left: props.x + "%",
        top: props.y + "%",
        width: props.w + "%",
        height: props.h + "%"
    }} ref={props.ref} />
}

function Cloakman (props : {
    tc : number,
    maxTc : number,
    ps : number
}) {
    const [check, setCheck] = useState(0);
    const speech = useRef(0);

    useMemo(() => {
        setCheck(check + 1);
    }, [props.ps, props.tc]);

    return <Stated
        check={check}
        states={[
            {
                index: 1,
                node: <Talker
                    src={cloaked_figure}
                    x={82} y={54.57} w={15}
                    flipH={true}
                    className="yes-events z-9"
                    onEnded={() => { 
                        speech.current = 1;
                        setCheck(check + 1);
                    }}
                    texts={[
                        "Bring me the stones.",
                        "With all 10 sacred hanging stones, I can form a cage.",
                        "He can't be killed...",
                        "But just maybe he can be contained..."
                    ]} position={DialoguePosition.Left}
                />,
                check: () => { return false; }
            },
            {
                index: 2,
                node: <Talker
                    src={cloaked_figure}
                    x={82} y={54.57} w={15}
                    flipH={true}
                    className="yes-events"
                    texts={[
                        "You have brought me " + props.tc + " stones.",
                        "I need " + (props.maxTc - props.tc) + " more."
                    ]} position={DialoguePosition.Left}
                />,
                check: () => { return speech.current == 1; }
            },
            {
                index: 3,
                node: <Talker
                    src={cloaked_figure}
                    x={82} y={54.57} w={15}
                    flipH={true}
                    className="yes-events"
                    texts={[
                        "The cage is formed!",
                        "Take it and contain him!"
                    ]} position={DialoguePosition.Left}
                />,
                check: () => { return props.ps == 1; },
                canSkipTo: true
            }
        ]}
    />
}

function Cage (props : {
    x: number,
    y: number,
    w: number,
    ps: number,
    onInLocation : () => void,
    onPowered : () => void,
    onUnpowered : () => void
}) {
    const id = useId();
    const posRef = useRef<Vector2>(new Vector2(0, 0));
    const [check, setCheck] = useState(0);

    const comp = useMemo(() => {
        if (props.ps === 4)
        {
            return <div className="pos-abs no-events" style={{
                left: props.x + "%",
                top: props.y + "%",
                width: props.w + "%",
                height: 656
            }}>
                <div className="pos-abs width-100p" style={{ top: posRef.current.y, left: posRef.current.x }}>
                    <Img100 src={cageback} className="pos-abs yes-events z-5 electric-pulse-3s" />
                    <Img100 src={cagefront} className="pos-abs yes-events z-7 electric-pulse-3s" />
                </div>
            </div>
        }

        return <div className="pos-abs no-events" style={{
            left: props.x + "%",
            top: props.y + "%",
            width: props.w + "%",
            height: 656
        }}>
            { 
                props.ps >= 1
                    ? <Plzma className="pos-abs width-100p height-512"
                            startOn={props.ps === 5 || props.ps === 4 || props.ps === 2}
                            onEnable={() => { 
                                props.onPowered(); 
                                setCheck(check + 1);
                            }}
                            onDisable={() => {
                                props.onUnpowered();
                                setCheck(check + 1);
                            }}
                            onState={
                                <div className="pos-abs width-100p" style={{ top: posRef.current.y, left: posRef.current.x }}>
                                    <Img100 src={cageback} className="pos-abs yes-events z-5 electric-pulse-3s" />
                                    <Img100 src={cagefront} className="pos-abs yes-events z-7 electric-pulse-3s" />
                                </div>
                            }
                            offState={
                                <FreeDrag id={id} x={posRef.current.x} y={posRef.current.y} w={"100%"} h={"656px"} targetId={SMOG_ID} onTarget={() => {
                                    props.onInLocation();
                                    setCheck(check + 1);
                                }} targetBehaviour={TargetBehavior.Stick} posRef={posRef}>
                                    <Img100 src={cageback} className="pos-abs yes-events z-5 bug-off" />
                                    <Img100 src={cagefront} className="pos-abs yes-events z-7 bug-off" />
                                </FreeDrag>
                            }
                    />
                    : null 
            }
        </div>
    }, [props.ps, check]);

    return comp;
}

function Smog (props: {
    ps: number,
    onDead: () => void;
}) {
    const [check, setCheck] = useState(0);
    let timer = 0;
    let animationFrame = 0;

    useMemo(() => {
        setCheck(check + 1);
    }, [props.ps]);

    const loop = () => {
        timer++;
        if (timer > 1200 && props.ps === 4)
            props.onDead();
        animationFrame = requestAnimationFrame(loop);
    };

    useEffect(() => {
        animationFrame = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(animationFrame);
        }
    }, [props]);

    return <Stated 
        id={"Smog"}
        check={check}
        states={[
            {
                index: 1,
                node: <Talker
                    id={SMOG_ID}
                    src={skeleton_beast}
                    x={10} y={95.71} w={80}
                    bubbleClass="smog-bubble rumble-1s"
                    className="z-6 yes-events"
                    autotalk={true}
                    bubbleWidth={512}
                    texts={[
                        "WAUUH HA HA HA",
                        "I CANNOT BE DEFEATED",
                        "CORRUPTION IS INEVITABLE",
                        "HIS BUNS ARE DEVITALIZED!!",
                        "ALL YOUR BUNS WILL BE!!"
                    ]} position={DialoguePosition.Above}
                />,
                check: () => { return props.ps <= 2; }
            },
            {
                index: 2,
                node: <Talker
                    id={SMOG_ID}
                    src={skeleton_beast}
                    x={10} y={95.71} w={80}
                    bubbleClass="smog-bubble rumble-1s"
                    className="z-6 yes-events"
                    autotalk={true}
                    bubbleWidth={512}
                    texts={[
                        "YOU THINK THAT WILL CONTAIN ME?",
                        "FOOL! YOU ABSOLUTE IMBECILE!!",
                        "ME, CONTAINED BY SIMPLE ROCKS?? NONSENSE!!",
                        "I WILL DECIMATE YOU, BUFFOON!!",
                        "CORRUPTION IS INEVITABLE!"
                    ]} position={DialoguePosition.Above}
                />,
                check: () => { return props.ps === 3; }
            },
            {
                index: 3,
                node: <Talker
                    id={SMOG_ID}
                    src={skeleton_beast}
                    x={10} y={95.71} w={80}
                    bubbleClass="smog-bubble rumble-1s"
                    className="z-6 yes-events rumble-1s"
                    autotalk={true}
                    bubbleWidth={512}
                    texts={[
                        "WHAT IS THIS???",
                        "WAIT... NO!",
                        "THESE ARE... THE STONES!",
                        "NOOOOOOOO",
                        "I AM CONTAINED"
                    ]} position={DialoguePosition.Above}
                />,
                check: () => { return props.ps === 4; }
            },
            {
                index: 4,
                node: <div className="pos-abs z-6" style={{
                    left: "10%",
                    top: "95.71%",
                    width: "80%"
                }}>
                    <Img100 src={skeleton_beast} className="pos-abs filter-grayscale" />
                </div>,
                check: () => { return props.ps === 5; }
            },
        ]}
    />
}

function PageWipe (props: {
    ps : number,
    onComplete : () => void;
}) {
    let animationFrame = 0;
    let timer = useRef(0);
    let complete = useRef(false);

    const loop = () => {
        timer.current++;
        if (timer.current > 1000 && !complete.current)
        {
            props.onComplete();
            complete.current = true;
        }
        animationFrame = requestAnimationFrame(loop);
    }

    useEffect(() => {
        animationFrame = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(animationFrame);
        }
    }, [props]);

    return props.ps === 5
        ? <div className="pos-abs bg-white fade-in-10s yes-events z-11" style={{ top: 0, bottom: 0, left: 0, right: 0 }} />
        : null
}